import * as yup from 'yup'

const REQUIRED_FIELD_MSG = 'This field is required.'
const PASSWORD_MIN_LENGTH = 'Password must be at least 6 characters.'
const PASSWORD_MATCH = 'Passwords must match.'
const INVALID_EMAIL = 'Invalid email format.'
const AGREEMENT_REQUIRED = 'You must accept the terms and conditions to continue.'
export enum FIELDS {
  EMAIL = 'email',
  PASSWORD = 'password',
  REPEAT_PASSWORD = 'repeatPassword',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  DISPLAY_NAME = 'displayName',
  TIMEZONE = 'timezone',
  EULA_ACCEPTED = 'eulaAccepted',
}

export const schemaStepTwo = yup.object({
  [FIELDS.EMAIL]: yup.string().trim().required(REQUIRED_FIELD_MSG).email(INVALID_EMAIL),
  [FIELDS.PASSWORD]: yup.string().trim().required(REQUIRED_FIELD_MSG).min(6, PASSWORD_MIN_LENGTH),
  [FIELDS.REPEAT_PASSWORD]: yup
    .string()
    .trim()
    .required(REQUIRED_FIELD_MSG)
    .oneOf([yup.ref(FIELDS.PASSWORD)], PASSWORD_MATCH),
})
export const schemaStepThree = yup.object({
  [FIELDS.FIRST_NAME]: yup.string().trim().required(REQUIRED_FIELD_MSG),
  [FIELDS.LAST_NAME]: yup.string().trim().required(REQUIRED_FIELD_MSG),
  [FIELDS.DISPLAY_NAME]: yup.string().trim().required(REQUIRED_FIELD_MSG),
  [FIELDS.TIMEZONE]: yup.string().trim().required(REQUIRED_FIELD_MSG),
  [FIELDS.EULA_ACCEPTED]: yup.boolean().oneOf([true], AGREEMENT_REQUIRED).required(AGREEMENT_REQUIRED),
})
